import React from 'react';
import wordmark from '../assets/img/Lodgeic-Wordmark.png';

// The Lodgeic lockup, redrawn as SVG so the mark can animate and the wordmark
// can follow the theme. Coordinates are traced from Lodgeic-Logo.png (the mark
// at its origin, the wordmark offset to where it sits in the original file).
const BUILDINGS = [
  { x: 15, y: 106, w: 56, h: 102, windows: [[33, 128, 20, 25], [33, 166, 20, 42]] },
  { x: 91, y: 53, w: 66, h: 155, windows: [[112, 76, 24, 30], [112, 120, 24, 30], [112, 164, 24, 44]] },
  { x: 178, y: 1, w: 84, h: 207, windows: [[200, 24, 39, 42], [200, 79, 39, 40], [200, 131, 39, 40], [200, 184, 39, 24]] },
];

const rectPath = (x, y, w, h) => `M${x} ${y}h${w}v${h}h${-w}Z`;

// Lights come on floor by floor, bottom to top, across the skyline.
const LIT_ORDER = BUILDINGS
  .flatMap((b) => b.windows)
  .sort((a, b) => b[1] + b[3] - (a[1] + a[3]) || a[0] - b[0]);

export default function LoginBrand() {
  return (
    <div className="lg-brand">
      <svg className="lg-brand-svg" viewBox="0 0 1155 266" role="img" aria-label="Lodgeic">
        <defs>
          <mask id="lg-wordmark-mask">
            <image href={wordmark} x="301" y="19" width="854" height="247" />
          </mask>
        </defs>
        <g className="lg-brand-mark">
          <rect className="lg-brand-ground" x="0" y="208" width="278" height="15" />
          {BUILDINGS.map((b, i) => (
            <path
              key={b.x}
              className="lg-brand-building"
              style={{ '--i': i }}
              fillRule="evenodd"
              d={rectPath(b.x, b.y, b.w, b.h) + b.windows.map((w) => rectPath(...w)).join('')}
            />
          ))}
          {LIT_ORDER.map(([x, y, w, h], i) => (
            <rect key={`${x}-${y}`} className="lg-brand-light" style={{ '--i': i }} x={x} y={y} width={w} height={h} />
          ))}
        </g>
        <rect className="lg-brand-word" x="301" y="19" width="854" height="247" mask="url(#lg-wordmark-mask)" />
      </svg>
    </div>
  );
}
